import React from 'react';
const initialState = {
            content: <img className="img-fluid" src={require('../images/smartinspect.JPG')} />,
            networkInfo: "Hi",
        };

export default initialState;